import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { COLORS, FONTS } from '../../theme/tokens';
import { PANEL_SX, PRIMARY_BUTTON_SX } from '../../theme/v2Styles';

const EmptyState = ({
  icon,
  title,
  description,
  actionLabel,
  actionTo,
  onAction,
  compact = false,
  titleComponent = 'h1',
}) => (
  <Box
    data-testid="empty-state"
    sx={{
      ...PANEL_SX,
      px: { xs: 3, md: 5 },
      py: compact ? { xs: 4, md: 5 } : { xs: 5, md: 7 },
      textAlign: 'center',
    }}
  >
    <Box
      sx={{
        width: 56,
        height: 56,
        borderRadius: '50%',
        bgcolor: COLORS.surfaceWarm,
        color: COLORS.gold,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 2,
        '& svg': { fontSize: 28 },
      }}
    >
      {icon}
    </Box>
    <Typography
      component={titleComponent}
      sx={{
        fontFamily: FONTS.heading,
        fontWeight: 600,
        fontSize: { xs: '1.375rem', md: '1.625rem' },
        color: COLORS.textPrimary,
        mb: 1,
      }}
    >
      {title}
    </Typography>
    <Typography sx={{ color: COLORS.textBody, maxWidth: 480, mx: 'auto', lineHeight: 1.65 }}>
      {description}
    </Typography>
    {actionLabel && (actionTo || onAction) && (
      <Button
        component={actionTo ? RouterLink : 'button'}
        to={actionTo}
        onClick={onAction}
        variant="contained"
        sx={{ ...PRIMARY_BUTTON_SX, mt: 3, px: 4 }}
      >
        {actionLabel}
      </Button>
    )}
  </Box>
);

export default EmptyState;
